<template>
  <v-container fluid class="text-center mt-5">
    <v-row>
      <v-col cols="12">
        <v-card class="rounded-xl elevation-5">
          <v-toolbar dense dark color="blue" elevation="2">
            <v-toolbar-title>Recursos</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text small :disabled="loading || !isWriting" @click="dialogs.new = true">
              Agregar
              <v-icon right>mdi-plus</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-title>
            <v-btn small outlined :loading="loading" color="blue" class="mx-2" elevation="0" :disabled="!isWriting" @click="refreshResources()">
              Actualizar
              <v-icon right>mdi-refresh</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line hide-details></v-text-field>
          </v-card-title>
          <v-card-text>
            <v-data-table dense :headers="headers" :items="items" :loading="loading" :search="search"
            :footer-props="{ 'items-per-page-text': 'Elementos por página', 'itemsPerPageAllText': 'Todos' }" :items-per-page="5" item-key="recursoID" class="mt-5">
              <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
              <template v-slot:item.actions="{ item }">
                <v-icon class="mr-2" color="primary" :disabled="!isReading" @click="view(item)">mdi-eye</v-icon>
                <v-icon class="mr-2" color="error" :disabled="!isWriting" @click="remove(item)">mdi-delete</v-icon>
              </template>
              <template v-slot:footer.page-text="props">
                Página {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
              </template>
              <template v-slot:no-data>
                No hay información disponible
              </template>
              <template v-slot:no-results>
                No se obtuvieron resultados
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="dialogs.new" persistent scrollable max-width="600px">
      <v-card class="rounded-xl elevation-16">
        <v-toolbar dense dark color="blue" elevation="2">
          <v-toolbar-title>Nuevo recurso</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn text small :disabled="loading" @click="cancel()">
            Cerrar
            <v-icon right>mdi-close</v-icon>
          </v-btn>
          <v-btn text small :loading="loading" :disabled="!isWriting" @click="save()">
            Guardar
            <v-icon right>mdi-check</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-form ref="formNew" lazy-validation v-on:submit.prevent>
              <v-row>
                <v-col cols="12">
                  <v-text-field prepend-icon="mdi-account-lock" v-model="forms.new.recurso" 
                  label="Recurso" :rules="[rules.required, rules.max100]" :disabled="loading" 
                  maxlength=100 required></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogs.detail" persistent scrollable max-width="600px">
      <v-card class="rounded-xl elevation-16">
        <v-toolbar dense dark color="blue" elevation="2">
          <v-toolbar-title>Detalle recurso</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn text small :disabled="loading" @click="cancel()">
            Cerrar
            <v-icon right>mdi-close</v-icon>
          </v-btn>
          <v-btn text small :disabled="loading || !isWriting" @click="update()">
            Actualizar
            <v-icon right>mdi-check</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-form ref="formDetail" lazy-validation v-on:submit.prevent>
              <v-row>
                <v-col cols="12">
                  <v-text-field prepend-icon="mdi-account-lock" v-model="forms.detail.recurso" 
                  label="Recurso" :rules="[rules.required, rules.max100]" :disabled="loading" 
                  maxlength=20 required></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogs.remove" persistent max-width="400">
      <v-card>
        <v-toolbar dense dark color="blue" elevation="0">
          <v-toolbar-title>Aviso importante</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <p class="mt-5 text-h6">¿Desea eliminar el recurso?</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small text :disabled="loading" color="blue-grey" @click="cancel()">
            Cancelar
          </v-btn>
          <v-btn small text :loading="loading" color="error" :disabled="!isRemoving" 
          @click="remove()">
            Eliminar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="success" color="success" :timeout="2500" bottom right>
      {{ msgSuccess }}
    </v-snackbar>
    <v-snackbar v-model="error" color="error" :timeout="2500" bottom right>
      {{ msgError }}
    </v-snackbar>
  </v-container>
</template>

<script>
import services from '@/utils/services'
import { infoBtn }   from '@/components'

export default {
  name: 'resources',
  components: { infoBtn },
  data: () => ({
    visible: false,
    loading: false,
    loadingResources: false,
    success: false,
    msgSuccess: '',
    msgError: '',
    error: false,
    codeError: '',
    search: '',
    nameCSV: 'Recursos'+'-'+new Date().getDate()+'-'+new Date().getMonth()+'-'+new Date().getFullYear()+'.csv',
    headers: [
      { text: 'Recurso', align: 'center', sortable: true, value: 'recurso' },
      { text: 'Acciones', align: 'center', sortable: true, value: 'actions' },
    ],
    items: [],
    itemsCSV: [],
    routes: [
      { text: 'Inicio', disabled: false, href: 'Home', icon: 'mdi-home', color:'blue' },
      { text: 'Seguridad', disabled: false, href: 'recursos', icon: 'mdi-server-security', color:'blue' },
      { text: 'Recursos', disabled: true, href: 'recursos', icon: 'mdi-cloud-lock' },
    ],
    allResources: [], 
    allResourcesToShow: [],
    filterResources: false,
    textFilter: 'Todos',
    forms: {
      new: {
        recurso: ''
      },
      detail: {
        recurso: ''
      }
    },
    rules: {
      required: v => !!v || 'El campo es obligatorio',
      max100: v => (v || '').length <= 100 || 'Limite de caracteres'
    },
    selected: null,
    dialogs: {
      new: false,
      detail: false,
      remove: false,
    }
  }),
  mounted() {
    if (this.isReading) {
      this.refresh();
    }
  },
  computed: {
    isReading: function() {
      return services.check(1, this.$route.path)
    },
    isWriting: function() {
      return services.check(2, this.$route.path)
    },
    isRemoving: function() {
      return services.check(3, this.$route.path)
    }
  },
  methods: {
    refreshResources() {
      this.loading = true;
      services.ws('get', 'recursos').then(res => {
        if(res.ok) {
          this.items = res.data;
        } else {
          this.error = true;
          this.codeError = res.code
        }
      }).finally(() => {
        this.loading = false;
      })    
    },
    refresh() {
      this.refreshResources();
    },
    cancel() {
      if (this.$refs.formNew) {
        this.$refs.formNew.resetValidation()
      }
      this.forms = {
        new: {
          recurso: ''
        },
        detail: {
          detail: ''
        }
      }
      this.selected = null
      this.dialogs.new = false
      this.dialogs.detail = false
      this.dialogs.remove = false
    },
    dataCSV(){
      if(this.items.length == 0){
        this.error = true
        this.codeError = 'CSV_NO_DATA'
      }else{
        this.itemsCSV = this.items;
        this.success = true
        this.msgSuccess = 'Descargando documento'
      }
      this.refresh();
    },
    view(item) {
      this.forms.detail.recurso = item.recurso;
      this.forms.detail.recursoID = item.recursoID;
      this.dialogs.detail = true;
    },
    save() {
      if(this.$refs.formNew.validate()) {
        this.loading = true;
        let newData = {};
        for (var key in this.forms.new) {
          if (this.forms.new[key] !== '') {
            newData[key] = this.forms.new[key]
          }
        }
        let data = {
          data: newData
        }
        services.ws('post', 'recursos', data).then(res => {
          if(res.ok) {
            this.cancel();
            this.refresh();
            this.success = true;
            this.msgSuccess = 'Recurso creado correctamente';
          } else {
            this.error = true
            if(res.code == 'DUPLICATE_RECORD') {
              this.codeError = res.code;
            } else {
              this.codeError = 'NO_ACTION';
            }
          }
        }).finally(() => {
          this.loading = false;
        })
      } else {
        this.error = true
        this.codeError = 'INVALID_INPUT'
      }
    },
    update() {
      if(this.$refs.formDetail.validate()) {
        this.loading = true;
        this.detailData = {};
        let detailData = {};
        for (var key in this.forms.detail) {
          if (this.forms.detail[key] !== '') {
            detailData[key] = this.forms.detail[key]
          }
        }
        let data = {
          data: detailData
        }
        services.ws('put', 'recursos', data).then(res => {
          if(res.ok) {
            this.cancel();
            this.refresh();
            this.success = true;
            this.msgSuccess = 'Recurso actualizado correctamente';
          } else {
            this.error = true
            if(res.code == 'DUPLICATE_RECORD') {
              this.codeError = res.code;
            } else {
              this.codeError = 'NO_ACTION';
            }
          }
        }).finally(() => {
          this.loading = false;
        });
      }
    },
    remove(item) {
      if (!this.dialogs.remove) {
        this.selected = JSON.parse(JSON.stringify(item))
        this.dialogs.remove = true
      } else {
        this.loading = true;
        let data = {
          data: {
            recursoID: parseInt(this.selected.recursoID)
          }
        }
        services.ws('delete', 'recursos', data).then(res => {
          if(res.ok) {
            this.cancel()
            this.refresh();
            this.success = true;
            this.msgSuccess = 'Recurso elimiando correctamente';
          } else {
            this.error = true;
            this.codeError = 'NO_ACTION';
          }
        }).finally(() => {
          this.loading = false;
        })
      }
    },
    filterResourcesChange() {
      if(this.filterResources) { 
        this.textFilter = 'Asignados';
        this.allResourcesToShow = [];
        this.allResourcesToShow = this.selectedResources;
      } else {
        this.textFilter = 'Todos';
        this.allResourcesToShow = this.allResources;
      }
    },
    closeMsg(){
      this.error=false
    }
  }
}
</script>

<style scoped>
</style>
